var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_100_493)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 32,
    height: 32,
    rx: 8.53333,
    fill: "#E3EDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.175 19.6684L31.825 30.262C31.7952 31.1693 31.413 32.0292 30.7595 32.6593C30.106 33.2895 29.2328 33.6401 28.325 33.6369H21.675C20.7678 33.6401 19.895 33.29 19.2417 32.6606C18.5883 32.0312 18.2057 31.1722 18.175 30.2655L17.825 19.6684C17.8173 19.4363 17.9022 19.2107 18.0609 19.0412C18.2195 18.8717 18.4391 18.7722 18.6711 18.7645C18.9032 18.7569 19.1288 18.8417 19.2983 19.0004C19.4678 19.1591 19.5673 19.3786 19.575 19.6106L19.925 30.2069C19.9424 30.6592 20.1345 31.0872 20.4608 31.401C20.7871 31.7147 21.2223 31.8898 21.675 31.8895H28.325C28.7783 31.8898 29.214 31.7142 29.5404 31.3997C29.8668 31.0852 30.0584 30.6564 30.075 30.2034L30.425 19.6106C30.4327 19.3786 30.5322 19.1591 30.7017 19.0004C30.8712 18.8417 31.0968 18.7569 31.3289 18.7645C31.5609 18.7722 31.7804 18.8717 31.9391 19.0412C32.0978 19.2107 32.1827 19.4363 32.175 19.6684ZM33.3326 16.143C33.3326 16.3751 33.2404 16.5976 33.0763 16.7617C32.9122 16.9258 32.6897 17.018 32.4576 17.018H17.5432C17.3112 17.018 17.0886 16.9258 16.9245 16.7617C16.7604 16.5976 16.6682 16.3751 16.6682 16.143C16.6682 15.9109 16.7604 15.6884 16.9245 15.5243C17.0886 15.3602 17.3112 15.268 17.5432 15.268H20.2557C20.533 15.2688 20.8006 15.1663 21.0065 14.9807C21.2124 14.795 21.3418 14.5394 21.3696 14.2635C21.4342 13.6164 21.7373 13.0166 22.22 12.5808C22.7027 12.145 23.3303 11.9046 23.9806 11.9063H26.0194C26.6697 11.9046 27.2973 12.145 27.78 12.5808C28.2626 13.0166 28.5658 13.6164 28.6304 14.2635C28.6582 14.5394 28.7876 14.795 28.9935 14.9807C29.1994 15.1663 29.467 15.2688 29.7442 15.268H32.4567C32.6888 15.268 32.9114 15.3602 33.0755 15.5243C33.2396 15.6884 33.3317 15.9109 33.3317 16.143H33.3326ZM22.8886 15.268H27.1131C26.9981 15.0053 26.9229 14.7269 26.89 14.442C26.8683 14.2263 26.7674 14.0264 26.6067 13.8809C26.446 13.7354 26.237 13.6547 26.0202 13.6545H23.9815C23.7647 13.6547 23.5558 13.7354 23.3951 13.8809C23.2344 14.0264 23.1334 14.2263 23.1117 14.442C23.0785 14.7269 23.0039 15.0053 22.8886 15.268ZM23.7697 28.5251V21.0745C23.7697 20.8424 23.6776 20.6199 23.5135 20.4558C23.3494 20.2917 23.1268 20.1995 22.8947 20.1995C22.6627 20.1995 22.4401 20.2917 22.276 20.4558C22.1119 20.6199 22.0197 20.8424 22.0197 21.0745V28.5286C22.0197 28.7607 22.1119 28.9833 22.276 29.1474C22.4401 29.3114 22.6627 29.4036 22.8947 29.4036C23.1268 29.4036 23.3494 29.3114 23.5135 29.1474C23.6776 28.9833 23.7697 28.7607 23.7697 28.5286V28.5251ZM27.982 28.5251V21.0745C27.982 20.8424 27.8898 20.6199 27.7257 20.4558C27.5616 20.2917 27.3391 20.1995 27.107 20.1995C26.8749 20.1995 26.6524 20.2917 26.4883 20.4558C26.3242 20.6199 26.232 20.8424 26.232 21.0745V28.5286C26.232 28.7607 26.3242 28.9833 26.4883 29.1474C26.6524 29.3114 26.8749 29.4036 27.107 29.4036C27.3391 29.4036 27.5616 29.3114 27.7257 29.1474C27.8898 28.9833 27.982 28.7607 27.982 28.5286V28.5251Z",
    fill: "#F23636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_100_493",
    x: 0.466666,
    y: 0.6,
    width: 49.0667,
    height: 49.0667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.13333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.26667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_100_493"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_100_493",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.68f6ebf55eea9e14379dbb794c6175fb.svg";
export { ForwardRef as ReactComponent };